// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2UBk0","error":"Textarea_error__3h7f0","readonly":"Textarea_readonly__DMAfh","disabled":"Textarea_disabled__1Bwdz"};